export enum PageError {
  NO_INTERNET,
  NO_CONNECTION,
  NOT_FOUND,
  UNKNOWN
}
